import {connect} from 'react-redux'
import CreateCustomer from '../components/CreateCustomer'
import _ from 'lodash'

import {appSetVal, appSetObj, appSetServerVal, checkFields, appCall} from '../../../../store/application'
import {findAddress, createServiceCustomer, doCustomerSearch, uploadPhoto} from "../modules/checkcashing";

const mapDispatchToProps = {
  appSetVal: appSetVal,
  appSetObj: appSetObj,
  appSetServerVal: appSetServerVal,
  checkFields: checkFields,
  appCall: appCall,
  findAddress: findAddress,
  createServiceCustomer: createServiceCustomer,
  doCustomerSearch: doCustomerSearch,
  uploadPhoto: uploadPhoto,
};

const mapStateToProps = (state) => {
  const {
    customer_search_term, create_new_customer_mode, s_customer_first_name, s_customer_middle_name,
    s_customer_last_name, s_customer_gender, s_customer_email, s_customer_ssn, s_customer_cell_phone, s_customer_home_phone,
    s_customer_dob, s_customer_status, s_customer_address, customer_address_search_results, s_customer_photo,
    s_customer_photo_id_front, s_customer_photo_id_back, s_customer_address1, s_customer_address2, s_customer_address_city,
    s_customer_address_state, s_customer_address_zip, s_customer_id_type, s_customer_id_number, s_customer_id_issuer,
    s_customer_id_expiration_date,
    s_customer_cell_phone_error, s_customer_email_error, s_customer_ssn_duplicated, s_customer_id_duplicated,
    create_customer_in_process, do_search_in_progress,
    s_customer_list,
    image_file_path, photo_uploading_in_progress
  } = state.app.x_data;

  return {
    disable_do_search: do_search_in_progress || !(!!customer_search_term),
    customer_search_term, create_new_customer_mode, s_customer_first_name, s_customer_middle_name,
    s_customer_last_name, s_customer_gender, s_customer_email, s_customer_ssn, s_customer_cell_phone, s_customer_home_phone,
    s_customer_dob, s_customer_status, s_customer_address, s_customer_photo, s_customer_photo_id_front,
    s_customer_photo_id_back, s_customer_address1, s_customer_address2, s_customer_address_city, s_customer_address_state,
    s_customer_address_zip, s_customer_id_type, s_customer_id_number, s_customer_id_issuer, s_customer_id_expiration_date,
    create_customer_in_process,
    s_customer_cell_phone_error, s_customer_email_error, s_customer_ssn_duplicated, s_customer_id_duplicated,
    customer_address_search_results: _.map(customer_address_search_results, (item, key) => (
      { ...item, key: key, text: item.value }
    )),
    do_search_in_progress,
    s_customer_list,
    image_file_path, photo_uploading_in_progress,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateCustomer)


// WEBPACK FOOTER //
// ./src/components/Applications/CheckCashing/containers/CreateCustomerContainer.js